module.exports = __webpack_public_path__ + "static/stardust-image-fluid-a450d134a0dc8f12ae54781000f3fd8b.png";